import React from "react";
import './FullParagraph.css' 


export default props => (
    <div className="full-paragraph">
      {props.block.text}
    </div>
  );